export default {
      id: "icon-studio-usage",
      viewBox: "0 0 464 464",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-studio",
      toString: function () {
        return this.url;
      }
    }